import { render, staticRenderFns } from "./nav-top.vue?vue&type=template&id=22c75e7a&scoped=true"
import script from "./nav-top.vue?vue&type=script&lang=js"
export * from "./nav-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c75e7a",
  null
  
)

export default component.exports